module.exports = __webpack_public_path__ + "static/media/8.619fb911.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/8.png
// module id = 1105
// module chunks = 0